// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page-specific styles for EventFormPage - Tavern Theme */

.ttbFormContainer {
  max-width: 800px;
  margin: 0 auto;
  padding: var(--space-4);
}

.ttbFormHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  padding: var(--space-4);
  background: var(--color-wood-800);
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
}

/* EventForm-specific header layout: keep title centered with a hidden right-side spacer */
.ttbEventFormPage .ttbFormHeaderSpacer {
  visibility: hidden;
  pointer-events: none;
}

.ttbFormHeaderTitle {
  flex: 1;
  text-align: center;
  font-family: var(--font-heading);
  font-size: 22px;
  font-weight: 700;
  color: var(--color-parchment-100);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
}

.ttbFormHeaderTitle::before {
  content: '📜';
  font-size: 24px;
}

@media (max-width: 425px) {
  .ttbEventFormPage .ttbFormHeaderTitle {
    font-size: 18px;
  }

  .ttbEventFormPage .ttbFormHeaderTitle::before {
    font-size: 18px;
  }
}

/* Form Sections */
.ttbFormSection {
  background: var(--color-parchment-100);
  border: 3px solid var(--color-wood-700);
  border-radius: var(--radius-xl);
  padding: var(--space-5);
  margin-bottom: var(--space-4);
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.06) 0%, transparent 50%);
}

.ttbFormSectionHeader {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-3);
  border-bottom: 2px solid var(--color-wood-600);
}

.ttbFormSectionIcon {
  font-size: 24px;
}

.ttbFormSectionTitle {
  font-family: var(--font-heading);
  font-size: 20px;
  font-weight: 700;
  color: var(--color-fire-600);
}

.ttbField {
  margin-bottom: var(--space-4);
}

.ttbField:last-child {
  margin-bottom: 0;
}

.ttbFieldLabel {
  display: block;
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: var(--space-2);
}

.ttbFieldLabel-required::after {
  content: ' *';
  color: var(--color-danger-500);
}

.ttbFieldError {
  margin-top: var(--space-2);
  font-size: 12px;
  color: var(--color-danger-500);
  font-weight: 600;
}

.ttbFieldHint {
  margin-top: var(--space-2);
  font-size: 12px;
  color: var(--color-text-secondary);
}

.ttbEventFormNotice {
  margin: 0 0 var(--space-4);
  padding: var(--space-3);
  border: 1px solid var(--color-wood-500);
  border-radius: var(--radius-md);
  background: var(--color-parchment-200);
}

.ttbInput {
  width: 100%;
  padding: var(--space-3);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  font-family: var(--font-body);
  font-size: 14px;
  background: white;
  color: var(--color-text-primary);
  outline: none;
  transition: all var(--transition-fast);
}

.ttbInput:focus {
  border-color: var(--color-fire-600);
  box-shadow: 0 0 0 3px rgba(184, 71, 14, 0.1);
}

.ttbInput:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--color-parchment-200);
}

.ttbInput option,
.ttbInput optgroup {
  background: white;
  color: var(--color-text-primary);
}

.ttbInputTextArea {
  resize: vertical;
  min-height: 96px;
  line-height: 1.5;
}

.ttbInputError {
  border-color: var(--color-danger-500);
  border-width: 2px;
}

.ttbInputError:focus {
  box-shadow: 0 0 0 3px rgba(168, 52, 42, 0.1);
}

.ttbTimeRow {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: var(--space-2);
}

.ttbTimeSeparator {
  font-weight: 800;
  font-family: var(--font-heading);
  color: var(--color-wood-600);
  font-size: 18px;
}

.ttbStepper {
  height: 48px;
  border-radius: var(--radius-md);
  border: 2px solid var(--color-wood-600);
  background: white;
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  align-items: center;
  overflow: hidden;
}

.ttbStepperError {
  border-color: var(--color-danger-500);
}

.ttbStepperButton {
  height: 100%;
  border: none;
  background: transparent;
  color: var(--color-fire-600);
  font-size: 24px;
  font-weight: 900;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.ttbStepperButton:hover:not(:disabled) {
  background: var(--color-fire-600);
  color: white;
}

.ttbStepperButton:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.ttbStepperValue {
  text-align: center;
  font-weight: 700;
  font-family: var(--font-heading);
  color: var(--color-text-primary);
  font-size: 15px;
}

/* Radio group for visibility */
.ttbRadioGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}

@media (max-width: 768px) {
  .ttbRadioGroup {
    grid-template-columns: 1fr;
  }
}

.ttbRadioOption {
  position: relative;
}

.ttbRadioOption input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.ttbRadioLabel {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-4);
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  text-align: center;
  background: white;
}

.ttbRadioOption input:checked + .ttbRadioLabel {
  border-color: var(--color-fire-600);
  background: rgba(184, 71, 14, 0.05);
  box-shadow: 0 0 0 2px rgba(184, 71, 14, 0.1);
}

.ttbRadioLabel:hover {
  border-color: var(--color-fire-500);
  transform: translateY(-2px);
}

.ttbRadioIcon {
  font-size: 32px;
  margin-bottom: var(--space-2);
}

.ttbRadioText {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 14px;
  color: var(--color-text-primary);
  margin-bottom: var(--space-1);
}

.ttbRadioHint {
  font-size: 12px;
  color: var(--color-text-secondary);
}

/* Segmented control - DEPRECATED, use radio group */
.ttbSegmented {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 2px solid var(--color-wood-600);
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--color-parchment-100);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.ttbSegmentedButton {
  height: 44px;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  font-weight: 700;
  font-family: var(--font-heading);
  font-size: 14px;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.ttbSegmentedButton:hover:not(:disabled) {
  background: var(--color-parchment-200);
}

.ttbSegmentedButtonActive {
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
}

.ttbSegmentedButtonActive:hover {
  background: var(--color-fire-500);
}

.ttbFormActions {
  position: sticky;
  bottom: 0;
  background: var(--color-wood-800);
  border-top: 3px solid var(--color-wood-700);
  padding: var(--space-4);
  margin: var(--space-5) calc(var(--space-4) * -1) calc(var(--space-4) * -1);
  display: flex;
  gap: var(--space-3);
  justify-content: flex-end;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);
}

@media (max-width: 768px) {
  .ttbFormActions {
    flex-direction: column-reverse;
  }
}

@media (min-width: 768px) {
  .ttbFormActions {
    margin: var(--space-5) 0 0;
    bottom: var(--space-4);
    border: 3px solid var(--color-wood-700);
    border-radius: var(--radius-lg);
  }
}

.ttbButtonSubmit {
  height: 52px;
  min-width: 200px;
  border-radius: var(--radius-lg);
  border: 2px solid var(--color-wood-700);
  background: var(--color-fire-600);
  color: var(--color-parchment-100);
  font-weight: 700;
  font-family: var(--font-heading);
  font-size: 16px;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-md);
}

.ttbButtonSubmit:hover:not(:disabled) {
  background: var(--color-fire-500);
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.ttbButtonSubmit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.ttbButtonOutlineHeader {
  padding: var(--space-2) var(--space-4);
  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-600);
  color: var(--color-parchment-100);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.ttbButtonOutlineHeader:hover:not(:disabled) {
  background: var(--color-wood-600);
  transform: translateY(-1px);
}

.ttbButtonOutlineHeader:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ttbDangerAction {
  width: 100%;
  height: 44px;
  border: 2px solid var(--color-danger-500);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-danger-500);
  font-weight: 700;
  font-family: var(--font-heading);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.ttbDangerAction:hover:not(:disabled) {
  background: var(--color-danger-500);
  color: var(--color-parchment-100);
}

.ttbDangerAction:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Invite Section Styles */
.ttbInviteHint {
  margin-bottom: var(--space-3);
}

.ttbInviteButtons {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-3);
}

.ttbInviteButtonsRow {
  display: flex;
  gap: var(--space-3);
}

.ttbInviteButton {
  flex: 1;
}

.ttbInviteButton--reserve {
  width: 100%;
}

.ttbCancelEventButton {
  margin-top: var(--space-4);
}

`, "",{"version":3,"sources":["webpack://./src/pages/EventForm/EventFormPage.css"],"names":[],"mappings":"AAEA,0DAA0D;;AAE1D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B;;mFAEiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,uCAAuC;EACvC,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iCAAiC;EACjC,2CAA2C;EAC3C,uBAAuB;EACvB,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uCAAuC;IACvC,+BAA+B;EACjC;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;EACvC,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["@import '../_base.css';\n\n/* Page-specific styles for EventFormPage - Tavern Theme */\n\n.ttbFormContainer {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: var(--space-4);\n}\n\n.ttbFormHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-5);\n  padding: var(--space-4);\n  background: var(--color-wood-800);\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n}\n\n/* EventForm-specific header layout: keep title centered with a hidden right-side spacer */\n.ttbEventFormPage .ttbFormHeaderSpacer {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.ttbFormHeaderTitle {\n  flex: 1;\n  text-align: center;\n  font-family: var(--font-heading);\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--color-parchment-100);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n}\n\n.ttbFormHeaderTitle::before {\n  content: '📜';\n  font-size: 24px;\n}\n\n@media (max-width: 425px) {\n  .ttbEventFormPage .ttbFormHeaderTitle {\n    font-size: 18px;\n  }\n\n  .ttbEventFormPage .ttbFormHeaderTitle::before {\n    font-size: 18px;\n  }\n}\n\n/* Form Sections */\n.ttbFormSection {\n  background: var(--color-parchment-100);\n  border: 3px solid var(--color-wood-700);\n  border-radius: var(--radius-xl);\n  padding: var(--space-5);\n  margin-bottom: var(--space-4);\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.06) 0%, transparent 50%);\n}\n\n.ttbFormSectionHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n  padding-bottom: var(--space-3);\n  border-bottom: 2px solid var(--color-wood-600);\n}\n\n.ttbFormSectionIcon {\n  font-size: 24px;\n}\n\n.ttbFormSectionTitle {\n  font-family: var(--font-heading);\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n}\n\n.ttbField {\n  margin-bottom: var(--space-4);\n}\n\n.ttbField:last-child {\n  margin-bottom: 0;\n}\n\n.ttbFieldLabel {\n  display: block;\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-2);\n}\n\n.ttbFieldLabel-required::after {\n  content: ' *';\n  color: var(--color-danger-500);\n}\n\n.ttbFieldError {\n  margin-top: var(--space-2);\n  font-size: 12px;\n  color: var(--color-danger-500);\n  font-weight: 600;\n}\n\n.ttbFieldHint {\n  margin-top: var(--space-2);\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.ttbEventFormNotice {\n  margin: 0 0 var(--space-4);\n  padding: var(--space-3);\n  border: 1px solid var(--color-wood-500);\n  border-radius: var(--radius-md);\n  background: var(--color-parchment-200);\n}\n\n.ttbInput {\n  width: 100%;\n  padding: var(--space-3);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  font-family: var(--font-body);\n  font-size: 14px;\n  background: white;\n  color: var(--color-text-primary);\n  outline: none;\n  transition: all var(--transition-fast);\n}\n\n.ttbInput:focus {\n  border-color: var(--color-fire-600);\n  box-shadow: 0 0 0 3px rgba(184, 71, 14, 0.1);\n}\n\n.ttbInput:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: var(--color-parchment-200);\n}\n\n.ttbInput option,\n.ttbInput optgroup {\n  background: white;\n  color: var(--color-text-primary);\n}\n\n.ttbInputTextArea {\n  resize: vertical;\n  min-height: 96px;\n  line-height: 1.5;\n}\n\n.ttbInputError {\n  border-color: var(--color-danger-500);\n  border-width: 2px;\n}\n\n.ttbInputError:focus {\n  box-shadow: 0 0 0 3px rgba(168, 52, 42, 0.1);\n}\n\n.ttbTimeRow {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.ttbTimeSeparator {\n  font-weight: 800;\n  font-family: var(--font-heading);\n  color: var(--color-wood-600);\n  font-size: 18px;\n}\n\n.ttbStepper {\n  height: 48px;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--color-wood-600);\n  background: white;\n  display: grid;\n  grid-template-columns: 48px 1fr 48px;\n  align-items: center;\n  overflow: hidden;\n}\n\n.ttbStepperError {\n  border-color: var(--color-danger-500);\n}\n\n.ttbStepperButton {\n  height: 100%;\n  border: none;\n  background: transparent;\n  color: var(--color-fire-600);\n  font-size: 24px;\n  font-weight: 900;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.ttbStepperButton:hover:not(:disabled) {\n  background: var(--color-fire-600);\n  color: white;\n}\n\n.ttbStepperButton:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.ttbStepperValue {\n  text-align: center;\n  font-weight: 700;\n  font-family: var(--font-heading);\n  color: var(--color-text-primary);\n  font-size: 15px;\n}\n\n/* Radio group for visibility */\n.ttbRadioGroup {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-4);\n}\n\n@media (max-width: 768px) {\n  .ttbRadioGroup {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ttbRadioOption {\n  position: relative;\n}\n\n.ttbRadioOption input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.ttbRadioLabel {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: var(--space-4);\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-align: center;\n  background: white;\n}\n\n.ttbRadioOption input:checked + .ttbRadioLabel {\n  border-color: var(--color-fire-600);\n  background: rgba(184, 71, 14, 0.05);\n  box-shadow: 0 0 0 2px rgba(184, 71, 14, 0.1);\n}\n\n.ttbRadioLabel:hover {\n  border-color: var(--color-fire-500);\n  transform: translateY(-2px);\n}\n\n.ttbRadioIcon {\n  font-size: 32px;\n  margin-bottom: var(--space-2);\n}\n\n.ttbRadioText {\n  font-family: var(--font-heading);\n  font-weight: 700;\n  font-size: 14px;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-1);\n}\n\n.ttbRadioHint {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n/* Segmented control - DEPRECATED, use radio group */\n.ttbSegmented {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border: 2px solid var(--color-wood-600);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: var(--color-parchment-100);\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.ttbSegmentedButton {\n  height: 44px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-weight: 700;\n  font-family: var(--font-heading);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.ttbSegmentedButton:hover:not(:disabled) {\n  background: var(--color-parchment-200);\n}\n\n.ttbSegmentedButtonActive {\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n}\n\n.ttbSegmentedButtonActive:hover {\n  background: var(--color-fire-500);\n}\n\n.ttbFormActions {\n  position: sticky;\n  bottom: 0;\n  background: var(--color-wood-800);\n  border-top: 3px solid var(--color-wood-700);\n  padding: var(--space-4);\n  margin: var(--space-5) calc(var(--space-4) * -1) calc(var(--space-4) * -1);\n  display: flex;\n  gap: var(--space-3);\n  justify-content: flex-end;\n  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);\n}\n\n@media (max-width: 768px) {\n  .ttbFormActions {\n    flex-direction: column-reverse;\n  }\n}\n\n@media (min-width: 768px) {\n  .ttbFormActions {\n    margin: var(--space-5) 0 0;\n    bottom: var(--space-4);\n    border: 3px solid var(--color-wood-700);\n    border-radius: var(--radius-lg);\n  }\n}\n\n.ttbButtonSubmit {\n  height: 52px;\n  min-width: 200px;\n  border-radius: var(--radius-lg);\n  border: 2px solid var(--color-wood-700);\n  background: var(--color-fire-600);\n  color: var(--color-parchment-100);\n  font-weight: 700;\n  font-family: var(--font-heading);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  box-shadow: var(--shadow-md);\n}\n\n.ttbButtonSubmit:hover:not(:disabled) {\n  background: var(--color-fire-500);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.ttbButtonSubmit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.ttbButtonOutlineHeader {\n  padding: var(--space-2) var(--space-4);\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-600);\n  color: var(--color-parchment-100);\n  border-radius: var(--radius-md);\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.ttbButtonOutlineHeader:hover:not(:disabled) {\n  background: var(--color-wood-600);\n  transform: translateY(-1px);\n}\n\n.ttbButtonOutlineHeader:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ttbDangerAction {\n  width: 100%;\n  height: 44px;\n  border: 2px solid var(--color-danger-500);\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--color-danger-500);\n  font-weight: 700;\n  font-family: var(--font-heading);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.ttbDangerAction:hover:not(:disabled) {\n  background: var(--color-danger-500);\n  color: var(--color-parchment-100);\n}\n\n.ttbDangerAction:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Invite Section Styles */\n.ttbInviteHint {\n  margin-bottom: var(--space-3);\n}\n\n.ttbInviteButtons {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  margin-bottom: var(--space-3);\n}\n\n.ttbInviteButtonsRow {\n  display: flex;\n  gap: var(--space-3);\n}\n\n.ttbInviteButton {\n  flex: 1;\n}\n\n.ttbInviteButton--reserve {\n  width: 100%;\n}\n\n.ttbCancelEventButton {\n  margin-top: var(--space-4);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
